import {Button} from 'antd';
import React, {FC, useContext} from 'react';

import {EDITABLE_TABLE_LIST_NAME, EditableFormTableContext} from 'components/editable-table';
import {TEntity} from 'modules/data';
import {resetData, saveEditableData} from 'modules/data/data-actions';
import {EEntityType} from 'shared/constants/entities';
import {ERequestType} from 'shared/types/requests';
import {useAppDispatch} from 'store/config/hooks';

import {ITableActionProps} from '../table-action-types';

import './button-action-save-editable-modal.less';

export const ButtonActionSaveEditableModal: FC<ITableActionProps> = ({
    meta,
    entityName,
    onClose,
    ...props
}: ITableActionProps) => {
    const dispatch = useAppDispatch();
    const {initData, form, validation} = useContext(EditableFormTableContext);
    const {validateAllRows} = validation || {};

    const handleClick = async () => {
        const editTableData: TEntity[] = form?.getFieldsValue()[EDITABLE_TABLE_LIST_NAME];

        if (!editTableData || !editTableData?.length) return;
        try {
            // Валидация полей в таблице
            const isValid = validateAllRows ? await validateAllRows(editTableData) : false;
            if (isValid && form && initData && meta.referenceUrl) {
                editTableData.forEach(item => {
                    dispatch(saveEditableData(
                        entityName,
                        EEntityType.EDITABLE_TABLE,
                        ERequestType.PUT,
                        item,
                        true,
                        meta.referenceUrl,
                    ));
                });
                dispatch(resetData({entityName, entityType: EEntityType.EDITABLE_TABLE, loading: false}));
                if (onClose) {
                    onClose();
                }
            }
        } catch (e) {
            console.error('Произошла ошибка при сохранении данных: ', e);
        }
    };

    return (
        <Button
            className="button-save-editable"
            {...props}
            onClick={handleClick}
        >
            {meta.actionTitle}
        </Button>
    );
};
